const userProfile = {
  emailManaged: '邮箱由企业统一管理，如需修改，请联系管理员。',
  actions: {
    backToChat: '返回对话',
    close: '关闭档案页',
  },
  account: {
    title: '账户',
  },
  avatarEditor: {
    cancel: '取消',
    choose: '选择图片',
    chooseAnother: '重新选择',
    close: '关闭头像编辑',
    cropFailed: '头像裁切失败，请换一张图片重试。',
    edit: '编辑头像',
    fileHint: 'PNG / JPEG / GIF / WebP · 1MB',
    preview: '头像预览',
    remove: '移除头像',
    save: '保存头像',
    title: '编辑头像',
    zoom: '缩放',
  },
  errors: {
    accountUnavailable: '当前账号不可用，请联系管理员。',
    avatarEmpty: '请选择一张头像图片。',
    avatarInvalid: '头像图片无效，请换一张图片。',
    avatarTooLarge: '头像图片超过上传限制。',
    avatarUnsupported: '头像仅支持 PNG、JPEG、GIF 或 WebP。',
    forbidden: '你没有权限执行这个操作。',
    generic: '操作失败，请稍后重试。',
    missingPasswordFields: '请填写当前密码和新密码。',
    network: '网络异常，请检查连接后重试。',
    currentPasswordIncorrect: '当前密码不正确。',
    serviceUnavailable: '服务暂时不可用，请稍后重试。',
    sessionExpired: '登录状态已过期，请重新登录。',
    timezoneInvalid: '时区无效，请填写有效的 IANA timezone。',
  },
  fallbackName: '用户',
  fields: {
    confirmPassword: '确认新密码',
    currentPassword: '当前密码',
    displayName: '昵称',
    newPassword: '新密码',
  },
  loadErrorDescription: '无法读取当前账号资料。',
  loadErrorTitle: '档案加载失败',
  nameEditor: {
    cancel: '取消',
    close: '关闭昵称编辑',
    edit: '编辑昵称',
    placeholder: '输入你的显示昵称',
    submit: '保存昵称',
    title: '编辑昵称',
  },
  password: {
    cancel: '取消',
    close: '关闭密码编辑',
    hidePassword: '隐藏密码',
    modalTitle: '修改密码',
    reloginNotice: '密码保存成功后，当前会话会被撤销并返回登录页。',
    reset: '重置密码',
    showPassword: '显示密码',
    submit: '保存密码',
    title: '密码',
  },
  success: {
    avatarDeleted: '头像已移除',
    avatarUploaded: '头像已更新',
    passwordChanged: '密码已更新，请重新登录',
    profileSaved: '资料已保存',
    timezoneSaved: '时区设置已保存',
  },
  tabs: {
    basic: '基础信息',
    label: '档案分区',
  },
  title: '个人中心',
  timezone: {
    automatic: '自动',
    automaticDescription: '当前设备：{{location}} · {{timezone}}',
    automaticDescriptionUnavailable: '每次新对话读取当前设备时区；读取不到时使用 UTC',
    automaticWithDevice: '自动（{{timezone}}）',
    description: '控制 Agent 时间 context 和相关系统工具使用的时区。',
    searchEmpty: '没有匹配的时区',
    searchLabel: '搜索时区',
    searchPlaceholder: '搜索城市、时区名称、UTC offset 或 IANA ID',
    sectionTitle: '偏好设置',
    title: '时区',
  },
  validation: {
    confirmPasswordMismatch: '两次输入的新密码不一致。',
    currentPasswordRequired: '请输入当前密码。',
    nameRequired: '昵称不能为空。',
    newPasswordLength: '新密码至少需要 8 个字符。',
  },
}

export default userProfile
